import React from 'react'
import PeopleMembers from 'src/app/PeopleMembers/PeopleMembers'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { peopleMembersRouteProps } from 'src/navigation/routeProps'

const PeopleMembersAppRoute: AppRoute = {
  id: AppLocation.PeopleMembers,
  routeProps: peopleMembersRouteProps,
  component: <PeopleMembers />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default PeopleMembersAppRoute
